import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "paper-plane-2",
  "use": "paper-plane-2-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"paper-plane-2\"><path d=\"M6.475 10.117l3.04 4.057a.97.97 0 001.73-.403l2.1-11.184a.97.97 0 00-1.468-1.004L1.095 8.323a.97.97 0 00.514 1.794h4.866zm0 0H5.017v3.016a.97.97 0 001.516.802l1.854-1.264-1.912-2.554zm0 0l6.463-8.511\" stroke=\"currentColor\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/paper-plane-2.svg
// module id = FWO4
// module chunks = 39 44